import TriggerToken from '@apps/automation/admin/tokens/trigger'
import Search from '@admin/components/search'
import PropTypes from 'prop-types'
import React from 'react'

class Trigger extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    maha: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  _handleChoose = this._handleChoose.bind(this)

  render() {
    return <Search { ...this._getSearch() } />
  }

  _getSearch() {
    return {
      options: this._getTriggers(),
      group: true,
      search: false,
      format: TriggerToken,
      label: 'trigger',
      onChange: this._handleChoose,
      valueKey: 'value',
      textKey: 'value'
    }
  }

  _getTriggers() {
    const { maha } = this.context
    return maha.triggers.filter(trigger => {
      return [
        'automation:enrollment_created',
        'crm:tag_added',
        'crm:tag_removed',
        'crm:subscription_created',
        'crm:subscription_deleted'
      ].includes(`${trigger.app}:${trigger.code}`)
    }).map(trigger => ({ value: trigger, group: trigger.appTitle }))
  }

  _handleChoose(trigger) {
    this.props.onNext({
      trigger: `${trigger.app}:${trigger.code}`
    })
  }

}

export default Trigger
